import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = { class: "text-xs text-gray-600 dark:text-dark-text" }
const _hoisted_3 = { class: "flex items-center my-2" }
const _hoisted_4 = { class: "text-xs mr-2 text-gray-600 dark:text-dark-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "hover-hand border rounded p-4 hover:shadow-lg transition duration-150 hover:border-challenge text-gray-900 dark:bg-dark-500 dark:border-dark-400 dark:hover:border-challenge dark:text-dark-text",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.middleCl.id), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.middleCl.numberOfProblems) + " problems ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.calc2digit(_ctx.middleCl.progress)) + "% ", 1),
      _createVNode(_component_base_progress_bar, {
        colorType: "CHALLENGE",
        num: _ctx.calc2digit(_ctx.middleCl.progress)
      }, null, 8, ["num"])
    ])
  ]))
}